import Route from '@ember/routing/route';
import { service } from '@ember/service';
import ENV from '../config/environment';
import { isTesting } from '@embroider/macros';
const LOCALES = { 'en-us': 'en', 'zh-cn': 'cn', 'ja-jp': 'jp', 'ru-ru': 'ru' };

export default class IndexRoute extends Route {
  @service intl;
  @service logger;
  @service('aditools-analytics') analytics;
  @service('aditools-site') siteconfig;

  beforeModel() {
    // Ensure the presence of the terminal slash in the URL
    let url = window.location.href;
    let queryIndex = url.indexOf('?');
    if (queryIndex === -1) {
      queryIndex = url.length;
    }
    if (url[queryIndex - 1] !== '/') {
      let newUrl = url.substring(0, queryIndex) + '/' + url.substring(queryIndex);
      window.history.replaceState({}, '', newUrl);
    }
  }

  async model(params) {
    const configURL = ENV.rootURL.endsWith('/') ? ENV.rootURL + 'siteconfig.json' : ENV.rootURL + '/siteconfig.json';
    let htmlElement = document?.querySelector('html');
    let fullLanguage = htmlElement?.getAttribute('lang');
    if (!fullLanguage) fullLanguage = 'en-us';
    const defaultLanguage = params.lang ? params.lang : LOCALES[fullLanguage];
    await this.siteconfig.start(
      configURL,
      ENV.rootURL,
      defaultLanguage,
      this.intl.locales.concat('ru-ru'),
      this.logger,
    );
    if (this.siteconfig.FullLocale === 'ru-ru') {
      this.intl.setLocale(['en-us']);
    } else {
      this.intl.setLocale([this.siteconfig.FullLocale]);
    }
    this.analytics.start(
      ENV.toolname,
      this.siteconfig.AnalyticsUrl,
      false,
      isTesting(),
      ENV.environment === 'development',
      this.logger,
    );
    await this.setupToolsConfig();
  }

  async setupToolsConfig() {
    this['toolConfigData'] = {};
    const abortController = new AbortController();
    const suffix = this.siteconfig['ConfigUrl'] && this.siteconfig['ConfigUrl'].startsWith('/testdata') ? 'json' : 'js';
    const url = this.siteconfig['ConfigUrl']
      ? `${this.siteconfig['ConfigUrl']}/pstd.${suffix}`
      : `${this.siteconfig['CdpUrl']}/toolsconfig/pstd.js?id=${new Date().getTime().toString()}`;
    try {
      const response = await fetch(url, { signal: abortController.signal });
      if (response.status !== 200) {
        throw `HTTP Request Failed: ${response.status} ${response.statusText}`;
      }
      const jsonData = await response.json();
      this['toolConfigData'] = jsonData;
      return;
    } catch (error) {
      this.logger.error(`Fetch of ${url} failed: ${error}`);
      return;
    }
  }

  setupController(controller, model, transition) {
    super.setupController(controller, model, transition);
    controller.toolConfigData = Object.assign({}, this['toolConfigData']);
    delete this['toolConfigData'];
  }
}
